import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { reduxForm } from 'redux-form';

import { Input, Button } from 'common/components';
import { required } from 'common/form-validators';

const confirmPassword = (value, formValues) => {
  if (value && value !== formValues.resetPassword) {
    return "Passwords don't match";
  }

  return undefined;
};

const ResetPasswordForm = ({
  onSubmit,
  error,
  handleSubmit,
  valid,
  pristine,
  submitting,
}) => {
  return (
    <Fragment>
      <form onSubmit={handleSubmit(onSubmit)} className="auth__form">
        <Input
          name="resetPasswordCode"
          disabled={submitting}
          title="Code"
          type="text"
          validate={[required]}
        />

        <Input
          name="resetPassword"
          disabled={submitting}
          title="Password"
          type="password"
          validate={[required]}
        />

        <Input
          name="confirmResetPassword"
          disabled={submitting}
          title="Re-Type Password"
          type="password"
          validate={[required, confirmPassword]}
          validateOnChange
          validText="Passwords match"
        />

        {error && <div className="auth__form-error">{error}</div>}

        <div className={'field__group text--center'}>
          <Button
            type="submit"
            className="btn btn--primary"
            disabled={!valid || pristine || submitting}
          >
            CHANGE PASSWORD
          </Button>
        </div>
      </form>
    </Fragment>
  );
};

ResetPasswordForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,

  error: PropTypes.string,
  handleSubmit: PropTypes.func.isRequired,
  valid: PropTypes.bool.isRequired,
  pristine: PropTypes.bool.isRequired,
  submitting: PropTypes.bool.isRequired,
};

const WithFormResetPassword = reduxForm({
  form: 'resetPassword', // a unique identifier for this form
})(ResetPasswordForm);

export default WithFormResetPassword;



// WEBPACK FOOTER //
// ./src/pages/ForgotPassword/ResetPasswordForm.js